import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {BrokerReportGroup} from '../../types/BrokerReportGroup';
import {ApiUtility} from "../common/ApiUtility";
import {useRenderableDataStore} from "../common/hooks/useRenderableDataStore";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {BrokerPlanContent} from "./BrokerPlanContent";

type PublicBrokerPlanPageRouteParams = {
    token: string;
};

export let PublicBrokerPlanPage = function () {
    const params = useParams<PublicBrokerPlanPageRouteParams>();
    const dataStore = useRenderableDataStore({
        loaded: false,
        unavailable: false,
        brokerGroup: undefined as BrokerReportGroup | undefined,
        reportDate: '',
        generatedAt: '',
    });

    // Trigger the load of the plan on mount and if the token in the URL changes.
    useEffect(
        function () {
            loadPublicPlan();
        },
        ['' + params.token]
    );

    function loadPublicPlan() {
        ApiUtility.getPublicBrokerPlan('' + params.token)
            .then(function (planData) {
                // apiRequest resolves with the parsed body on every status outside 401/403/404/422/500, so a resolved error body means the link is unavailable too.
                if (!planData || !planData.brokerGroups) {
                    dataStore.updateAndRender({loaded: true, unavailable: true});
                    return;
                }

                dataStore.updateAndRender({
                    loaded: true,
                    brokerGroup: planData.brokerGroups[0],
                    reportDate: planData.reportDate,
                    generatedAt: planData.generatedAt,
                });
            })
            .catch(function () {
                dataStore.updateAndRender({loaded: true, unavailable: true});
            });
    }

    if (!dataStore.data().loaded) {
        return (
            <OverlayLoadingIndicator/>
        );
    }

    return (
        <div className="public-broker-plan-page">
            {/* @page cannot be scoped by selector, so only the mounted plan pages zero the printed page margins */}
            <style>{'@media print { @page { margin: 0; } }'}</style>
            {(() => {
                if (dataStore.data().unavailable) {
                    return (
                        <div className="public-broker-plan-unavailable">
                            This plan is unavailable.
                        </div>
                    );
                } else {
                    return (
                        <BrokerPlanContent
                            brokerGroup={dataStore.data().brokerGroup}
                            reportDate={dataStore.data().reportDate}
                            generatedAt={dataStore.data().generatedAt}
                        />
                    );
                }
            })()}
        </div>
    );
};
